import React from "react";
import PropTypes from "prop-types";
import { withFormik } from "formik";
import * as Yup from "yup";
import BasicInput from "../../forms/fields/BasicInput";
import BasicSelect from "../../forms/fields/BasicSelect";
import { COUNTRIES } from "../../../constants/countries";
import { baseValue } from "../../../libs/utils";

const CompanySubContactorForm = props => {
  const { subContractor } = props;
  return (
    <form className="m-login__form m-form" onSubmit={props.handleSubmit}>
      <div className="m-portlet__body">
        <input type="hidden" name="id" />
        <div className="form-group m-form__group row">
          <div className="col-xl-4">
            <BasicInput
              {...props}
              name="vat"
              type="text"
              label="VAT identification number"
              noFormGroup={true}
              placeholder="BE 0123.456.789"
            />
          </div>
          <div className="col-xl-8">
            <BasicInput
              {...props}
              name="name"
              type="text"
              label="Company Name"
              noFormGroup={true}
            />
          </div>
        </div>
        <div className="form-group m-form__group row">
          <div className="col-xl-7">
            <BasicInput
              {...props}
              name="addressLine1"
              type="text"
              label="Address"
              noFormGroup={true}
            />
          </div>
          <div className="col-xl-2">
            <BasicInput
              {...props}
              name="zip"
              type="text"
              label="Postal Code"
              noFormGroup={true}
            />
          </div>
          <div className="col-xl-3">
            <BasicInput
              {...props}
              name="city"
              type="text"
              label="City"
              noFormGroup={true}
            />
          </div>
        </div>

        <div className="form-group m-form__group row">
          <div className="col-xl-4">
            <BasicSelect
              {...props}
              name="country"
              label="Country"
              placeholder="Choose a country"
              noFormGroup={true}
              options={COUNTRIES.map(country => {
                return {
                  value: country.value,
                  title: country.label
                };
              })}
            />
          </div>

          <div className="col-xl-4">
            <BasicInput
              {...props}
              name="telephone"
              type="text"
              label="Phone"
              noFormGroup={true}
            />
          </div>
        </div>
      </div>
      <div className="m-portlet__foot">
        <div className="row align-items-center">
          <div className="col-lg-12 m--align-right">
            <button
              key="1"
              className={
                "btn m-btn btn-primary" +
                (props.isSubmitting
                  ? " m-btn--custom m-loader m-loader--light m-loader--left"
                  : "")
              }
              disabled={props.isSubmitting}
            >
              {subContractor ? "Update" : "Create"}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

CompanySubContactorForm.propTypes = {
  company: PropTypes.object
};

const mapPropsToValues = ({ subContractor }) => {
  const pCompany = baseValue(subContractor, {});
  let values = {
    name: baseValue(pCompany.name),
    addressLine1: baseValue(pCompany.addressLine1),
    zip: baseValue(pCompany.zip),
    city: baseValue(pCompany.city),
    country: baseValue(pCompany.country),
    telephone: baseValue(pCompany.telephone),
    vat: baseValue(pCompany.vat)
  };

  return values;
};

const validationSchema = Yup.object().shape({
  name: Yup.string().required("required"),
  addressLine1: Yup.string().required("required"),
  zip: Yup.string().required("required"),
  city: Yup.string().required("required"),
  country: Yup.string().required("required"),
  telephone: Yup.string().required("required"),
  vat: Yup.string().required("required")
});

const handleSubmit = (values, { props, setSubmitting }) => {
  props.onSubmit(values).then(() => {
    setSubmitting(false);
  });
};

export default withFormik({
  mapPropsToValues,
  validationSchema,
  handleSubmit
})(CompanySubContactorForm);
